export default "__VITE_ASSET__aDtcAnlV__"